export function resolveSubmittedIdentityType<T extends string | null | undefined>(
  isForeign: boolean,
  identityType: string,
  foreignIdentityType: T,
): string | T {
  return isForeign ? foreignIdentityType : identityType;
}
